/** 404 elegant. */
import { Link } from 'react-router-dom';
import { Logo } from '../components/Logo';

export function NotFoundPage() {
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14 }}>
        <div style={{ display: 'inline-flex', gap: 10, alignItems: 'center' }}>
          <Logo withWordmark />
        </div>
        <h1 className="bricolage" style={{ fontSize: 28, fontWeight: 800 }}>Pagina nu există</h1>
        <p style={{ margin: 0, color: 'var(--muted)', fontSize: 14 }}>Se pare că ai ajuns pe un drum înfundat.</p>
        <Link to="/dashboard" className="btn btn-primary">Înapoi la dashboard</Link>
      </div>
    </div>
  );
}
